<template>
  <d2-container>
    <div class="delivery-management-container">
      <!-- 返回按钮 -->
      <el-button
        icon="el-icon-back"
        @click="goBack"
        style="margin-bottom: 15px;"
      >
        返回
      </el-button>

      <!-- 模块一：基本信息展示 -->
      <el-card shadow="never" class="module-card">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="info-item">
              <span class="info-label">订单名称：</span>
              <span class="info-value">{{ orderInfo.order_no }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="info-label">客户名称：</span>
              <span class="info-value">{{ orderInfo.customer_name }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="info-label">资源类型：</span>
              <span class="info-value">{{ orderInfo.resource_type }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px;">
          <el-col :span="8">
            <div class="info-item">
              <span class="info-label">订单类型：</span>
              <span class="info-value">{{ formatOrderType(orderInfo.order_type) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="info-label">交付数量：</span>
              <span class="info-value">{{ orderInfo.dev_number }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="info-label">已交付数量：</span>
              <span class="info-value">{{ orderInfo.delivered_number }}</span>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 15px;">
          <el-col :span="8">
            <div class="info-item">
              <span class="info-label">订单起始时间：</span>
              <span class="info-value">{{ timeTime(orderInfo.starting_time) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="info-item">
              <span class="info-label">订单结束时间：</span>
              <span class="info-value">{{ timeTime(orderInfo.end_time) }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="detail-item">
              <span class="detail-label">订单状态：</span>
              <span class="detail-value">{{ formatStatus(orderInfo.status) }}</span>
            </div>
          </el-col>
        </el-row>
      </el-card>

      <!-- 模块三：已交付设备（可回收） -->
      <el-card shadow="hover">
        <div slot="header">
          <span>已交付设备（可回收）</span>
          <el-button
            type="danger"
            size="small"
            style="float: right; width: 120px;"
            :disabled="selectedRecycleDevices.length === 0"
            @click="handleOpenRecycleDialog"
          >
            回收
          </el-button>
          <el-tooltip
            :disabled="orderInfo.status === 2"
            content="只有订单状态为“生效中”时才能发起交付"
            placement="top"
          >
            <el-button
              type="primary"
              size="small"
              style="float: right; margin-right: 20px; width: 120px;"
              @click="handleShowDeliveryDialog"
              :disabled="orderInfo.status !== 2"
            >
              发起交付
            </el-button>
          </el-tooltip>
        </div>

        <el-table
          ref="recycleTable"
          :data="deliveredDevices"
          @selection-change="handleRecycleSelectionChange"
          border
          style="height: 100%; overflow-y: scroll;"
          :default-sort="{prop: 'delivery_time', order: 'descending'}"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
            :selectable="isRowSelectable"
          />
          <el-table-column prop="hostname" label="主机名" align="center" width="120" sortable />
          <el-table-column prop="host_ip" label="IP地址" align="center" width="120" sortable />
          <el-table-column label="状态" align="center" width="85" sortable>
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 0 ? 'success' : 'info'" size="small">
                {{ scope.row.status === 0 ? '已交付' : '已回收' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="delivery_time"
            label="交付时间"
            align="center"
            sortable
            :sort-method="(a, b) => new Date(a.delivery_time) - new Date(b.delivery_time)"
          />
          <el-table-column
              prop="recycle_time"
              label="回收时间"
              align="center"
              sortable
              :sort-method="(a, b) => new Date(a.recycle_time) - new Date(b.recycle_time)"
          />
          <el-table-column
            prop="start_time"
            label="计费开始时间"
            align="center"
            sortable
            :sort-method="(a, b) => new Date(a.start_time) - new Date(b.start_time)"
          />
          <el-table-column
              prop="ending_time"
              label="计费结束时间"
              align="center"
              sortable
              :sort-method="(a, b) => new Date(a.start_time) - new Date(b.start_time)"
          />
          <el-table-column prop="delivery_name" label="所属交付单" align="center" sortable>
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handleDownloadDeliveryDoc(scope.row)"
              >
                {{ scope.row.delivery_name }}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <!-- 弹窗1：发起交付 -->
      <el-dialog
        title="发起交付"
        :visible.sync="showDeliveryDialog"
        width="50%"
        :close-on-click-modal="false"
        @close="resetDeliveryForm"
      >
        <el-form :model="deliveryForm" label-width="120px" :rules="deliveryRules" ref="deliveryForm" :inline="false">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="订单ID" prop="order_id">
                <el-input v-model="deliveryForm.order_id" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="交付单号" prop="delivery_no">
                <el-input v-model="deliveryForm.delivery_no" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="交付名称" prop="delivery_name">
                <el-input v-model="deliveryForm.delivery_name" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="交付人" prop="delivery_user">
                <el-input v-model="deliveryForm.delivery_user" placeholder="请输入交付人" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="交付时间" prop="delivery_time">
                <el-date-picker
                  v-model="deliveryForm.delivery_time"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择交付时间"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计费开始时间" prop="billing_start_time">
                <el-date-picker
                  v-model="deliveryForm.billing_start_time"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择计费开始时间"
                  style="width: 100%;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input
                  v-model="deliveryForm.remark"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入备注"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 跳板机信息 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="跳板机协议" prop="jump_protocol">
                <el-radio-group v-model="deliveryForm.jump_protocol">
                  <el-radio label="SSH">SSH</el-radio>
                  <el-radio label="VPN">VPN</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="跳板机IP" prop="jump_ip">
                <el-input v-model="deliveryForm.jump_ip" placeholder="请输入跳板机IP" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="跳板机端口" prop="jump_port">
                <el-input v-model="deliveryForm.jump_port" placeholder="请输入跳板机端口" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="跳板机用户名" prop="jump_user">
                <el-input v-model="deliveryForm.jump_user" placeholder="请输入跳板机用户名" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="跳板机密码" prop="jump_password">
                <el-input v-model="deliveryForm.jump_password" type="password" placeholder="请输入跳板机密码" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计算节点用户名" prop="ai_node_user">
                <el-input v-model="deliveryForm.ai_node_user" placeholder="请输入计算节点用户名" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="计算节点密码" prop="ai_node_password">
                <el-input v-model="deliveryForm.ai_node_password" type="password" placeholder="请输入计算节点密码" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="管理节点IP" prop="mgmt_node_ip">
                <el-input v-model="deliveryForm.mgmt_node_ip" placeholder="请输入管理节点IP" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="管理节点用户名" prop="mgmt_node_user">
                <el-input v-model="deliveryForm.mgmt_node_user" placeholder="请输入管理节点用户名" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="管理节点密码" prop="mgmt_node_password">
                <el-input v-model="deliveryForm.mgmt_node_password" type="password" placeholder="请输入管理节点密码" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 价格方案选择 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="价格方案" prop="price_id">
                <el-select
                  v-model="deliveryForm.price_id"
                  placeholder="请选择价格方案"
                  style="width: 100%;"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="item in priceList"
                    :key="item.id"
                    :label="`${item.name} - ${item.unit_price}/${meteringUnitMap[item.metering_unit] || item.metering_unit}`"
                    :value="item.id"
                  >
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">
                      {{ item.unit_price }}/{{ meteringUnitMap[item.metering_unit] || item.metering_unit }}
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="交付数量" prop="dev_number" style="margin-top: 0;">
                <el-input-number
                  v-model="deliveryForm.dev_number"
                  :min="0"
                  :controls="false"
                  style="width: 100%; opacity: 0.7; pointer-events: none;"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 设备类型提示 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="设备类型限制">
                <span v-if="deliveryForm.price_id">
                  当前价格方案适用于：<strong>{{ getPriceCharacterLabel }}</strong>
                </span>
                <span v-else style="color: #999;">请选择价格方案以加载对应设备</span>
              </el-form-item>
            </el-col>
          </el-row>

          <h4 style="padding-left: 50px">
            选择设备（仅空闲且匹配类型）
            <el-tag
              size="small"
              :type="deliveryForm.dev_number > 0 ? 'primary' : 'info'"
            >
              已选 {{ deliveryForm.dev_number }} 台
            </el-tag>
          </h4>
          <el-transfer
            filterable
            :filter-method="filterDevice"
            filter-placeholder="请输入主机名或IP"
            v-model="deliveryForm.dev_ids"
            :data="transferDeviceList"
            :titles="['可用设备', '已选设备']"
            target-order="original"
            style="text-align: left; margin: 0 auto; margin-left: 50px;"
          >
            <span slot-scope="{ option }">
              {{ option.hostname }} <small style="color: #999;">({{ option.host_ip }})</small>
            </span>
          </el-transfer>
        </el-form>

        <div slot="footer">
          <el-button @click="showDeliveryDialog = false">取消</el-button>
          <el-button type="primary" @click="submitDelivery" :loading="submitLoading">
            提交
          </el-button>
        </div>
      </el-dialog>

      <!-- 弹窗2：回收设备 -->
      <el-dialog
        title="回收设备"
        :visible.sync="showRecycleDialog"
        :close-on-click-modal="false"
        width="50%"
      >
        <el-form :model="recycleForm" label-width="160px" :rules="recycleRules" ref="recycleForm">
          <el-form-item label="订单ID">
            <el-input v-model="recycleForm.order_id" disabled />
          </el-form-item>
          <el-form-item label="回收单号" prop="recycle_no">
            <el-input v-model="recycleForm.recycle_no" disabled />
          </el-form-item>
          <el-form-item label="回收时间" prop="recycle_time">
            <el-date-picker
              v-model="recycleForm.recycle_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择回收时间"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item label="结束计费时间" prop="billing_ending_time">
            <el-date-picker
              v-model="recycleForm.billing_ending_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择结束计费时间"
              style="width: 100%;"
            />
          </el-form-item>
          <el-form-item label="回收人" prop="recycle_user">
            <el-input v-model="recycleForm.recycle_user" placeholder="请输入回收人" />
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="recycleForm.remark"
              type="textarea"
              :rows="3"
              placeholder="请输入备注"
            />
          </el-form-item>
        </el-form>

        <div slot="footer">
          <el-button @click="showRecycleDialog = false">取消</el-button>
          <el-button type="danger" @click="submitRecycle" :loading="recycleLoading">
            确认回收
          </el-button>
        </div>
      </el-dialog>
    </div>
  </d2-container>
</template>

<script>
import util from '@/libs/util.js'
export default {
  name: 'DeliveryManagement',
  data() {
    return {
      orderInfo: {},
      deliveryList: [],
      deviceList: [],
      deliveredDevices: [],
      transferDeviceList: [],
      // 计费单位映射表：后端返回的 metering_unit 数字 → 显示文本
      meteringUnitMap: {
        1: '日',
        2: '卡·时',
        3: 'T·月',
        4: '台·月'
      },
      priceList: [], // 价格方案列表

      showDeliveryDialog: false,
      submitLoading: false,
      selectedDevices: [],

      deliveryForm: {
        order_id: '',
        delivery_no: '',
        delivery_name: '',
        delivery_time: '',
        billing_start_time: '',
        dev_number: 0,
        delivery_user: '',
        remark: '',
        dev_ids: [],
        hostnames: [],
        host_ips: [],
        provider_ids: [],
        provider_names: [],
        zone_ids: [],
        zone_names: [],
        price_id: null, // 绑定价格方案 ID
        jump_protocol: '',
        jump_ip: '',
        jump_port: '',
        jump_user: '',
        jump_password: '',
        ai_node_user: '',
        ai_node_password: '',
        mgmt_node_ip: '',
        mgmt_node_user: '',
        mgmt_node_password: ''
      },
      deliveryRules: {
        delivery_name: [{ required: true, message: '请输入交付名称', trigger: 'blur' }],
        delivery_time: [{ required: true, message: '请选择交付时间', trigger: 'change' }],
        delivery_user: [{ required: true, message: '请输入交付人', trigger: 'blur' }],
        billing_start_time: [{ required: true, message: '请选择计费开始时间', trigger: 'change' }],
        price_id: [{ required: true, message: '请选择价格方案', trigger: 'change' }],
        jump_protocol: [{ required: true, message: '请选择跳板机协议', trigger: 'change' }],
        jump_ip: [{ required: true, message: '请输入跳板机IP', trigger: 'blur' }],
        jump_port: [{ required: true, message: '请输入跳板机端口', trigger: 'blur' }],
        jump_user: [{ required: true, message: '请输入跳板机用户名', trigger: 'blur' }],
        jump_password: [{ required: true, message: '请输入跳板机密码', trigger: 'blur' }],
        ai_node_user: [{ required: true, message: '请输入计算节点用户名', trigger: 'blur' }],
        ai_node_password: [{ required: true, message: '请输入计算节点密码', trigger: 'blur' }]
      },

      showRecycleDialog: false,
      recycleLoading: false,
      selectedRecycleDevices: [],
      recycleForm: {
        order_id: '',
        recycle_no: '',
        recycle_time: '',
        billing_ending_time: '',
        recycle_user: '',
        remark: '',
        dev_ids: []
      },
      recycleRules: {
        recycle_time: [{ required: true, message: '请选择回收时间', trigger: 'change' }],
        billing_ending_time: [{ required: true, message: '请选择结束计费时间', trigger: 'change' }],
        recycle_user: [{ required: true, message: '请输入回收人', trigger: 'blur' }]
      },

      orderId: null,
      page: 1,
      pageSize: 10
    }
  },
  computed: {
    getPriceCharacterLabel() {
      if (!this.deliveryForm.price_id) return '请选择价格方案'

      const price = this.priceList.find(p => p.id === this.deliveryForm.price_id)
      if (!price) return '价格方案不存在'

      return price.dev_character ? price.dev_character : '未设置设备类型'
    }
  },
  watch: {
  'deliveryForm.price_id'(newVal) {
    if (!newVal) {
      this.transferDeviceList = []
      return
    }

    const selectedPrice = this.priceList.find(p => p.id === newVal)
    if (!selectedPrice || !selectedPrice.dev_character) {
      this.$message.warning('该价格方案缺少设备类型信息')
      this.transferDeviceList = []
      return
    }

    const targetCharacter = selectedPrice.dev_character

    this.$axios
      .get('/api-30216/api/devices', {
        params: { page: 1, pageSize: 999, active_state: 0 }
      })
      .then(res => {
        if (res.code === 200) {
          const devices = res.data || []
          this.transferDeviceList = devices
            .filter(d => d.dev_character === targetCharacter)
            .map(d => ({
              key: d.dev_id,
              label: `${d.hostname} (${d.host_ip || d.ip || 'N/A'})`,
              hostname: d.hostname,
              host_ip: d.host_ip || d.ip || '',
              dev_character: d.dev_character,
              provider: d.provider || '',
              provider_id: d.provider_id || '',
              az_name: d.az_name || '',
              az_id: d.az_id || ''
            }))

          // ✅ 只清空 dev_ids 和相关字段，不碰 dev_number
          this.deliveryForm.dev_ids = []
          this.deliveryForm.hostnames = []
          this.deliveryForm.host_ips = []
          this.deliveryForm.provider_ids = []
          this.deliveryForm.provider_names = []
          this.deliveryForm.zone_ids = []
          this.deliveryForm.zone_names = []

        } else {
          this.$message.error('获取设备列表失败')
          this.transferDeviceList = []
        }
      })
      .catch(() => {
        this.$message.error('请求设备列表失败')
        this.transferDeviceList = []
      })
  },
  'deliveryForm.dev_ids'(newVal, oldVal) {
    if (!newVal || newVal.length === 0) {
      this.deliveryForm.dev_number = 0
      this.deliveryForm.hostnames = []
      this.deliveryForm.host_ips = []
      this.deliveryForm.provider_ids = []
      this.deliveryForm.provider_names = []
      this.deliveryForm.zone_ids = []
      this.deliveryForm.zone_names = []
      return
    }
    if (!this.transferDeviceList || this.transferDeviceList.length === 0) return
    
    const selected = this.transferDeviceList.filter(d => newVal.includes(d.key))
    this.deliveryForm.dev_number = selected.length
    this.deliveryForm.hostnames = selected.map(d => d.hostname)
    this.deliveryForm.host_ips = selected.map(d => d.host_ip)
    this.deliveryForm.provider_ids = selected.map(d => d.provider_id)
    this.deliveryForm.provider_names = selected.map(d => d.provider)
    this.deliveryForm.zone_ids = selected.map(d => d.az_id)
    this.deliveryForm.zone_names = selected.map(d => d.az_name)
    
    // 生成 zone_names 字符串，去重并使用逗号分隔
    // const uniqueZoneNames = [...new Set(selected.map(d => d.az_name))].filter(Boolean)
    // this.deliveryForm.zone_names = uniqueZoneNames.join(',')
    
    const devicesWithoutIp = selected.filter(d => {
      const ip = d.host_ip
      return !ip || (typeof ip === 'string' && ip.trim() === '')
    })
    if (devicesWithoutIp.length > 0) {
      const deviceNames = devicesWithoutIp.map(d => d.hostname).join('、')
      this.$message.warning(`设备 ${deviceNames} 未设置IP，请前往非纳管设备编辑当前设备的设备IP`)
    }
  }
},
  created() {
    const { id, page, pageSize } = this.$route.query
    this.orderId = id
    this.page = Number(page) || 1
    this.pageSize = Number(pageSize) || 10

    if (!this.orderId) {
      this.$message.error('缺少订单ID')
      this.$router.back()
      return
    }

    this.initData()
  },
  methods: {
    formatStatus(value) {
      const map = {
        0: '草稿',
        1: '待审核',
        2: '生效中',
        3: '已终止',
        4: '已到期'
      };
      return map[value] || '-';
    },
    timeTime(datetime) {
      if (!datetime) return ''
      const date = new Date(datetime)
      const Y = date.getFullYear() + '-'
      const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      const D = (date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ')
      const h = (date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':')
      const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':')
      const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },

    initData() {
      this.deliveryForm.order_id = this.orderId
      this.recycleForm.order_id = this.orderId
      this.getOrderInfo()
      this.fetchDeliveryList().then(() => {
        this.fetchDeliveredDevices()
      })
    },

    getOrderInfo() {
      this.$axios.get(`/api-30216/api/orders/${this.orderId}`)
        .then(response => {
          if (response.data) {
            this.orderInfo = response.data
          } else {
            this.$message.error('未找到订单信息')
          }
        })
        .catch(error => {
          console.error('获取订单信息失败:', error)
          this.$message.error('获取订单信息失败')
        })
    },

    formatOrderType(value) {
      const map = { 0: '开口', 1: '闭口', 2: '售前测试' }
      return map[value] || '-'
    },

    fetchDeliveryList() {
      return this.$axios
        .get(`/api-30216/api/deliveries/orders/${this.orderId}`)
        .then(res => {
          if (res.code === 200) {
            const deliveries = res.data || []
            console.log('Delivery list data:', deliveries)
            this.deliveryList = deliveries.map(delivery => ({
              ...delivery,
              delivery_id: delivery.delivery_id || delivery.id
            }))
            console.log('Processed delivery list:', this.deliveryList)
          } else {
            this.$message.error(res.message || '获取交付记录失败')
          }
        })
        .catch(() => {
          this.$message.error('请求失败')
        })
    },

    filterDevice(query, item) {
      return item.hostname.toLowerCase().includes(query.toLowerCase()) ||
             (item.host_ip && item.host_ip.includes(query))
    },

    fetchDeliveredDevices() {
      this.$axios
        .get('/api-30216/api/deliveries/devices', {
          params: { order_id: this.orderId, page: 1, pageSize: 99999, }
        })
        .then(res => {
          if (res.code === 200) {
            const devices = res.data || []
            console.log('Delivered devices data:', devices)
            devices.forEach(device => {
              const matchedDelivery = this.deliveryList.find(d => d.delivery_name === device.delivery_name)
              if (matchedDelivery) {
                device.delivery_id = matchedDelivery.delivery_id || matchedDelivery.id
                console.log('Matched delivery for device:', device.delivery_name, '->', device.delivery_id)
              } else {
                console.log('No matching delivery for device:', device.delivery_name)
              }
            })
            this.deliveredDevices = devices
            console.log('Processed delivered devices:', this.deliveredDevices)
          } else {
            this.$message.error(res.message || '获取已交付设备失败')
          }
        })
        .catch(() => {
          this.$message.error('请求失败')
        })
    },

    // 获取价格方案列表（保留 dev_character）
    fetchPriceList() {
      this.$axios
        .get('/api-30216/api/orders/price_list', {
          params: { order_id: this.orderId }
        })
        .then(res => {
          if (res.code === 200) {
            if (!res.data) this.priceList = []
            else {
              this.priceList = res.data.filter(p => p.status===1).map(p => ({
                ...p,
                dev_character: p.dev_character
              }))
            }
          } else {
            this.$message.error(res.message || '获取价格方案失败')
            this.priceList = []
          }
        })
        .catch(err => {
          console.error('获取价格方案失败:', err)
          this.$message.error('请求价格方案失败')
          this.priceList = []
        })
    },

    handleShowDeliveryDialog() {
      this.fetchPriceList()

      this.deliveryForm = {
        order_id: this.orderId,
        delivery_no: 'DLV' + Date.now(),
        delivery_name: '',
        delivery_time: this.formatDateTime(new Date()),
        billing_start_time: this.formatDateTime(new Date()),
        dev_number: 0,
        delivery_user: '',
        remark: '',
        dev_ids: [],
        hostnames: [],
        host_ips: [],
        provider_ids: [],
        provider_names: [],
        zone_ids: [],
        zone_names: [],
        price_id: null,
        jump_protocol: '',
        jump_ip: '',
        jump_port: '',
        jump_user: '',
        jump_password: '',
        ai_node_user: '',
        ai_node_password: '',
        mgmt_node_ip: '',
        mgmt_node_user: '',
        mgmt_node_password: ''
      }

      this.transferDeviceList = []
      this.showDeliveryDialog = true
    },

    submitDelivery() {
      this.$refs.deliveryForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        this.$axios
          .post('/api-30216/api/deliveries/delivery_devices', this.deliveryForm, {
            headers: { 'Content-Type': 'application/json' },
            transformRequest: [data => JSON.stringify(data)]
          })
          .then(res => {
            if (res.code === 200) {
              this.$message.success('交付成功')
              this.showDeliveryDialog = false
              this.getOrderInfo()
              this.fetchDeliveryList().then(() => {
                this.fetchDeliveredDevices()
              })
            } else {
              this.$message.error(res.message || '交付失败')
            }
          })
          .catch(() => {
            this.$message.error('提交失败')
          })
          .finally(() => {
            this.submitLoading = false
          })
      })
    },

    resetDeliveryForm() {
      this.$refs.deliveryForm && this.$refs.deliveryForm.resetFields()
      this.transferDeviceList = []
      // 确保新字段被重置
      this.deliveryForm.provider_ids = []
      this.deliveryForm.provider_names = []
      this.deliveryForm.zone_ids = []
      this.deliveryForm.zone_names = []
    },

    isRowSelectable(row) {
      return row.status === 0
    },

    handleRecycleSelectionChange(selection) {
      this.selectedRecycleDevices = selection.map(item => item.dev_id)
    },

    handleOpenRecycleDialog() {
      if (this.selectedRecycleDevices.length === 0) {
        this.$message.warning('请先选择要回收的设备')
        return
      }

      this.recycleForm = {
        order_id: this.orderId,
        recycle_no: 'RCY' + Date.now(),
        recycle_time: this.formatDateTime(new Date()),
        billing_ending_time: this.formatDateTime(new Date()),
        recycle_user: '',
        remark: '',
        dev_ids: this.selectedRecycleDevices
      }
      this.showRecycleDialog = true
    },

    submitRecycle() {
      this.$refs.recycleForm.validate(valid => {
        if (!valid) return
        this.recycleLoading = true
        this.$axios
          .post('/api-30216/api/deliveries/recycle_devices', this.recycleForm, {
            headers: { 'Content-Type': 'application/json' },
            transformRequest: [data => JSON.stringify(data)]
          })
          .then(res => {
            if (res.code === 200) {
              this.$message.success('回收成功')
              this.showRecycleDialog = false
              this.$refs.recycleTable.clearSelection()
              this.getOrderInfo()
              this.fetchDeliveredDevices()
            } else {
              this.$message.error(res.message || '回收失败')
            }
          })
          .catch(() => {
            this.$message.error('提交失败')
          })
          .finally(() => {
            this.recycleLoading = false
          })
      })
    },

    goBack() {
      this.$router.push({
        path: '/api/orders',
        query: { page: this.page, pageSize: this.pageSize }
      })
    },

    formatDateTime(date) {
      const pad = n => n.toString().padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    },

    handleDownloadDeliveryDoc(row) {
      if (!row.delivery_id) {
        // 尝试从 deliveryList 中查找对应的 delivery_id
        const matchedDelivery = this.deliveryList.find(d => d.delivery_name === row.delivery_name)
        if (matchedDelivery) {
          row.delivery_id = matchedDelivery.delivery_id || matchedDelivery.id
        }
      }
      if (!row.delivery_id) {
        this.$message.warning('缺少交付单ID')
        return
      }
      console.log('Downloading delivery doc for delivery_id:', row.delivery_id)
      console.log('Delivery name:', row.delivery_name)
      
      // 直接使用原生 fetch API，避免 axios 响应拦截器的影响
      const url = `/api-30216/api/deliveries/download_doc?delivery_id=${row.delivery_id}`
      console.log('Fetch URL:', url)
      
      // 从 cookies 中获取 token
      const token = util.cookies.get('token')
      console.log('Using token from cookie:', token)
      
      fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'application/json'
        },
        credentials: 'include' // 包含 cookies
      })
      .then(response => {
        console.log('Fetch response status:', response.status)
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.blob()
      })
      .then(blob => {
        console.log('Fetched blob:', blob)
        if (!blob || blob.size === 0) {
          this.$message.error('下载内容为空')
          return
        }
        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `${row.delivery_name}_交付文档.docx`
        document.body.appendChild(link)
        link.click()
        // 清理
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 100)
        this.$message.success('下载成功')
      })
      .catch(err => {
        console.error('Download error:', err)
        this.$message.error('下载失败')
      })
    }
  }
}
</script>

<style scoped>
.module-card {
  margin-bottom: 20px;
}
.delivery-management-container {
  padding: 20px;
}
.el-card ::v-deep .el-card__header {
  padding: 12px 20px;
  font-weight: bold;
  font-size: 16px;
}
.el-transfer-panel {
  width: 260px !important;
}
.delivery-management-container ::v-deep .el-transfer-panel__item span {
  font-size: 14px;
}
.delivery-management-container ::v-deep .el-transfer-panel__filter .el-input__inner {
  font-size: 14px;
}
</style>
